<template>
    <div class="applicant-container text-primary">
        <div class="applicant-item">
            <input class="applicant-radio" type="radio" id="legal" v-model="model" value="LEGAL" autocomplete="off" name="applicant_type" :disabled="disabled_legal"/>
            <label class="applicant-label" for="legal">{{translate(locale.legal_person)}}</label>
        </div>
        <div class="applicant-item">
            <input class="applicant-radio" type="radio" id="physical" v-model="model" value="PHYSICAL" autocomplete="off" name="applicant_type" :disabled="disabled_physical"/>
            <label class="applicant-label" for="physical">{{translate(locale.physical_person)}}</label>
        </div>
    </div>   
  </template>
  <script>
    export default {
      props: {
        value: {},
        disabled_legal: {
            type: Boolean,
            default: false
        },
        disabled_physical: {
            type: Boolean,
            default: false
        },
      },
      data() {
        return {
          localValue: this.value
        }
      },
      created() {
        this.setFieldValue()
      },
      methods: {
        setFieldValue() {
          this.localValue = this.model
        },
      },
      watch: {
        model() {
          this.setFieldValue()
        },
        localValue(val) {
          this.$emit('input', val)
        },
        value(val) {
          this.localValue = val
        }
      },
      computed: {
        model: {
          get() {
            return this.localValue
          },
          set(value) {
            if (value.constructor.name.toLowerCase() !== 'inputevent') {
              this.$nextTick(() => {
                this.localValue = value
              })
            }
          }
        },
      }
    }
  </script>
  
  <style scoped>
    .applicant-container {
        display: flex;
        margin: 8px 0 15px 0;
    }
    .applicant-item {
        margin-right: 15px;
    }
    .applicant-radio:checked {
      accent-color: #353690;
    }
    .applicant-label {
      margin-left: 4px;
    }
  </style>


// WEBPACK FOOTER //
// src/components/Form/Applicant.vue